import styled from 'styled-components'

export const Grid = styled.div`
	position: relative;
	display: grid;
	justify-content: center;
	grid-template-columns: auto minmax(200px, 320px);

	@media only screen and (max-width: 1250px) {
		grid-template-columns: 1fr;
		flex-direction: column-reverse;
	}
`
